<template>
	<section class="body">
		<a class="spotty position-absolute" @dblclick.prevent="logout()"></a>
		<div class="stage" :style="fieldHeightText">
			<transition name="slide" mode="out-in" v-if="direction">
				<component :is="component" :data="guest" v-if="component" />
			</transition>

			<transition name="slideBack" mode="out-in" v-if="!direction">
				<component :is="component" :data="guest" v-if="component" />
			</transition>
		</div>

		<div class="keyboard-container" :class="{'show-keyboard': visible, 'numeric-keyboard': isNumeric}">
			<vue-touch-keyboard id="keyboard" v-if="visible" :layout="layout" :cancel="hide" :accept="accept" :input="input" :next="next" />
		</div>
		<CheckinFooter v-show="true"></CheckinFooter>
	</section>
</template>

<script>
	import Vue from 'vue'
	import axios from 'axios'
	import Vuelidate from 'vuelidate'
	import VueCardFormat from 'vue-credit-card-validation';
	Vue.use(Vuelidate)
	Vue.use(VueCardFormat)

	import VueTouchKeyboard from "vue-touch-keyboard";

	//import style from "vue-touch-keyboard/dist/vue-touch-keyboard.css"; // load default style
	Vue.use(VueTouchKeyboard)

	import CheckinStart from './../components/checkin/CheckinStart.vue'
	import CheckinSelectType from './../components/checkin/CheckinSelectType.vue'
	import CheckinLogin from './../components/checkin/CheckinLogin.vue'
	import CheckinMultiLastNames from './../components/checkin/CheckinMultiLastNames.vue'
	import CheckinBirthday from './../components/checkin/CheckinBirthday.vue'
	import CheckinZip from './../components/checkin/CheckinZip.vue'
	import CheckinForm from './../components/checkin/CheckinForm.vue'
	import CheckInFinish from './../components/checkin/CheckinFinish.vue'

	import CheckinCreditCard from './../components/checkin/CheckinCreditCard.vue'
	import CheckinSelectRoom from './../components/checkin/CheckinSelectRoom.vue'

	/** FOOTER COMPONENT **/
	import CheckinFooter from './../components/checkin/CheckinFooter.vue'

	import { API_URI } from "@/common/config";
	import { mapState } from 'vuex';

	export default {
		props: [],
		data: function () {
			return {
				fieldHeightText: 'transform:translateY(0)',
				focusField: null,
					step: 0,
					component: 'CheckinStart',
				guest: null,
				direction: true,

				/* CC CARD */
				$cardFormat: Vue.prototype.$cardFormat,

				/* VUE TOUCH KEYBOARD */
				visible: false,
				isNumeric: false,
				layout: 'normal',
				input: null,
				options: {
					useKbEvents: false
				},
				nnLayoutCompact: {
					_meta: {
						"default": {keySet: "default", text: "abc", classes: "control"},
						"alpha": {keySet: "default", text: "Abc", classes: "control"},
						"shift": {keySet: "shifted", text: "ABC", classes: "control"},
						"numbers": {keySet: "numbers", text: "123", classes: "control"},
						"space": {key: " ", text: "Space", width: 200},
						"backspace": {func: "backspace", classes: "control"},
						"accept": {func: "accept", text: "Close", classes: "control featured"},
						"next": {func: "next", text: "Next", classes: "featured"},
						"zero": {key: "0", width: 130}
					},

					default: [
						"1 2 3 4 5 6 7 8 9 0 {backspace}",
						"Q W E R T Y U I O P Ü",
						"A S D F G H J K L Ö Ä",
						"Z X C V B N M ẞ ' _",
						"- . {space} @ {accept}"
					],

					shifted: [
						"Q W E R T Y U I O P",
						" A S D F G H J K L ",
						"{default} Z X C V B N M ",
						"{numbers} _ - {space} {backspace} {accept}"
					],

					numbers: [
						"1 2 3",
						"4 5 6",
						"7 8 9",
						". {zero} {backspace} {accept}"
					]
				},
				nnLayoutNumeric: {
					_meta: {
						"backspace": { func: "backspace", classes: "control"},
						"accept": { func: "accept", text: "Close", classes: "control featured"},
						"next": { func: "next", text: "Next", classes: "control featured"},
						"zero": { key: "0", width: 90}
					},

					default: [
						"1 2 3",
						"4 5 6",
						"7 8 9",
						"- . {zero} {backspace} {accept}"
					]
				}
			}
		},
		computed: {
			...mapState('settings', ['config']),
		},
		mounted: function() {

//			var script = document.createElement("script");
//			script.async = true;
//			script.defer = true;
//			script.src = require('../assets/js/script.js');
//			document.getElementsByTagName("head")[0].appendChild(script);

		},
		methods: {
			/** Keyboard Events **/
			accept(text) {
				// console.log("Input text: " + text);
				this.hide();
			},
			show(e) {
				this.input = e.target;
				this.layout = e.target.dataset.layout;
				if(e.target.dataset.layout == 'numeric') {
					this.layout = this.nnLayoutNumeric;
					this.isNumeric = true;
				} else {
					this.isNumeric = false;
				}

				if(e.target.dataset.layout == 'compact') {
					this.layout = this.nnLayoutCompact;
				}

				this.fieldHeightText = 'transform:translateY('+e.target.dataset.height+'px)';

				if (!this.visible)
					this.visible = true
			},

			hide() {
				this.visible = false;
				this.fieldHeightText = 'transform:translateY(0)';
			},

			next() {
				// this.fieldHeightText = 'transform:translateY(0)';
				let inputs = document.querySelectorAll("input");
				let found = false;
				[].forEach.call(inputs, (item, i) => {
					if (!found && item == this.input && i < inputs.length - 1) {
						found = true;
						this.$nextTick(() => {
							inputs[i+1].focus();
						});
					}
				});
				if (!found) {
					this.input.blur();
					this.hide();
				}
			},

			logout: function() {
			 	axios({
					method: 'get',
					url: this.config.apiUrl + 'logout',
					withCredentials: true
				}).then(response => (
					this.logoutFunc()
				))
			},

			logoutFunc: function() {
				window.localStorage.setItem('authUser',null);
				var cookieData = 'PHPSESSID=;domain='+ window.location.host + ';expires=Thu, 01 Jan 1970 00:00:01 GMT;';
				document.cookie = cookieData;
				var cookieData = 'PHPSESSID=;domain=backend.'+ window.location.host + ';expires=Thu, 01 Jan 1970 00:00:01 GMT;';
				document.cookie = cookieData;

				var redirectUrl = window.location.protocol + "//" + window.location.host + "/#/login";
				window.document.location.href = redirectUrl;
			}


		},
		components: {
			CheckinStart,
			CheckinSelectType,
			CheckinLogin,
			CheckinMultiLastNames,
			CheckinBirthday,
			CheckinZip,
			CheckinForm,

			CheckinCreditCard,
			CheckinSelectRoom,

			CheckInFinish,

			CheckinFooter
		}
	}
</script>

<style scoped lang="scss">
	// eslint-disable-next-line
	/* eslint-disable */

	.stage {
		transition: 0.5s all;
	}
	.slide-enter-active {
		transition: all .35s ease-in-out;
		transform: translateX(25%);
		opacity: 0;
	}

	.slide-leave-active {
		transition: all .35s ease-in-out;
		transform: translateX(0);
		opacity: 1;
	}

	.slide-enter-to {
		transform: translateX(0);
		opacity: 1;
	}

	.slide-leave-to {
		transform: translateX(-25%);
		opacity: 0;
	}


	/* Back Sliding */

	.slideBack-enter-active {
		transition: all .35s ease-in-out;
		transform: translateX(-25%);
		opacity: 0;
	}

	.slideBack-leave-active {
		transition: all .35s ease-in-out;
		transform: translateX(0);
		opacity: 1;
	}

	.slideBack-enter-to {
		transform: translateX(0);
		opacity: 1;
	}

	.slideBack-leave-to {
		transform: translateX(25%);
		opacity: 0;
	}

	.panel-body {
		padding: 15px;
	}

	.spotty {
		left: 0;
		top: 0;
		width: 30px;
		height: 30px;
		color: transparent !important;

		/*
			top: auto;
			left: auto;
			bottom: 90px;
			right: 0;
		*/
	}
</style>
